import {JsonProperty} from '../shared/decorators/json-property';

export class User {
  @JsonProperty('user_id')
  id: number;
  @JsonProperty('group_id')
  groupId: number;
  @JsonProperty('group_name')
  role: string;
  @JsonProperty('is_delete')
  isDeleted: boolean;
  username: string;
  login: string;
  password: string;
  confirmPassword: string;
  constructor() {
    this.id = undefined;
    this.groupId = undefined;
    this.role = undefined;
    this.isDeleted = undefined;
    this.login = undefined;
    this.username = undefined;
    this.password = undefined;
    this.confirmPassword = undefined;
  }
}
